import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";
import KcsTech from "../../../Assets/Logo/k-logo-cult2.png";
import "./Footer.css";

/* ── Data ──────────────────────────────────────────────── */
const socialLinks = [
  {
    name: "Instagram",
    url: "https://www.instagram.com/kapil_tech_it_staffing/",
    icon: (
      <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="18" height="18">
        <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
      </svg>
    ),
  },
  {
    name: "Linkedin",
    url: "https://www.linkedin.com/company/kapiltech",
    icon: (
      <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="18" height="18">
        <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
      </svg>
    ),
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/KapilTechnologies?ref=pages_you_manage",
    icon: (
      <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="18" height="18">
        <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" />
      </svg>
    ),
  },
  {
    name: "X-Twitter",
    url: "https://x.com/_Kapil_Tech",
    icon: (
      <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="18" height="18">
        <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
      </svg>
    ),
  },
  // {
  //   name: "Youtube",
  //   url: "https://www.youtube.com/channel/UCu7yQ0nQT38MI4KrN2sczPg",
  //   icon: (
  //     <svg viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="18" height="18">
  //       <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" />
  //     </svg>
  //   ),
  // },
];

const serviceLinks = [
  { text: "AI & ML Staffing Service", url: "/services/technology/ai-ml" },
  { text: "SAP Staffing Service", url: "/services/erpservices/sap" },
  { text: "Infor Staffing Service", url: "/services/erpservices/infor" },
  { text: "Odoo Staffing Service", url: "/services/erpservices/odoo" },
  { text: "Cloud Staffing Service", url: "/services/technology/cloud" },
];

const companyLinks = [
  { text: "About Us", url: "/insights/aboutus" },
  { text: "Insights", url: "/insights/blog" },
  { text: "Webinar", url: "/insights/webinar" },
  { text: "Job Connecter Bootcamp", url: "/careers/job-connecter-bootcamp" },
  { text: "Business Development Team", url: "/careers/bde-team" },
];

const officeLocations = [
  "Singapore",
  "Indonesia",
  "India",
  "United States",
];

const contactInfo = {
  email: "info@kapiltech.com",
  phone: "+91 88899 92746",
  address: "#13-01, 105 Cecil Street, The Octagon - 069534",
};

/* ── Accordion for mobile ──────────────────────────────── */
const AccordionSection = ({ title, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="ft-accordion">
      <button
        className="ft-accordion-trigger"
        onClick={() => setOpen((p) => !p)}
        aria-expanded={open}
      >
        <span>{title}</span>
        {open ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
      </button>
      <div className={`ft-accordion-body ${open ? "ft-accordion-open" : ""}`}>
        {children}
      </div>
    </div>
  );
};

/* ── Main Footer ───────────────────────────────────────── */
const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="ft-footer">
      {/* ── DESKTOP LAYOUT ─────────────────────────────── */}
      <div className="ft-desktop">
        <div className="ft-inner">
          {/* Desktop Columns Grid */}
          <div className="ft-columns">
            {/* Row 1, Col 1 – Discover */}
            <div className="ft-col ft-col-desc">
              <h4 className="ft-col-heading ft-col-heading--primary">Discover</h4>
              <p className="ft-desc-text">
                A technology-focused staffing partner connecting high-growth companies with skilled IT, engineering, and digital professionals.
              </p>
            </div>


            {/* Row 1, Col 2 – Services */}
            <div className="ft-col">
              <h4 className="ft-col-heading ft-col-heading--primary">Services</h4>
              <ul className="ft-link-list">
                {serviceLinks.map((l) => (
                  <li key={l.url}>
                    <Link to={l.url} onClick={scrollToTop}>{l.text}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Row 1, Col 3 – Global Presence */}
            <div className="ft-col">
              <h4 className="ft-col-heading ft-col-heading--primary">Global Presence</h4>
              <ul className="ft-link-list">
                {officeLocations.map((loc) => (
                  <li key={loc}>{loc}</li>
                ))}
              </ul>
            </div>

            {/* Row 1, Col 4 – Logo (Moved from above) */}
            <div className="ft-col ft-col-logo">
              <Link to="/" onClick={scrollToTop}>
                <img src={KcsTech} alt="Kapil Technologies logo" className="ft-logo" />
              </Link>
            </div>

            {/* Row 2, Col 1 – Company */}
            <div className="ft-col">
              <h4 className="ft-col-heading ft-col-heading--primary">Company</h4>
              <ul className="ft-link-list">
                {companyLinks.map((l) => (
                  <li key={l.url}>
                    <Link to={l.url} onClick={scrollToTop}>{l.text}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Row 2, Col 2 – Contact Us */}
            <div className="ft-col ft-col-address">
              <h4 className="ft-col-heading ft-col-heading--primary">Contact Us</h4>
              <ul className="ft-link-list ft-contact-list">
                <li>
                  <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
                </li>
                <li>
                  <a href={`tel:${contactInfo.phone.replace(/\s/g, "")}`}>{contactInfo.phone}</a>
                </li>
                <li>
                  #13-01, 105 Cecil Street, <br />
                  The Octagon - 069534
                </li>
              </ul>
            </div>

            {/* Row 2, Col 3 – Follow Us */}
            <div className="ft-col">
              <h4 className="ft-col-heading ft-col-heading--primary">Follow Us</h4>
              <div className="ft-social-icons">
                {socialLinks.map((s) => (
                  <a
                    key={s.name}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.name}
                    className="ft-social-icon"
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Row 2, Col 4 – Animated shape (Moved to end of second row) */}
            <div className="ft-shape-col">
              <div className="ft-animation-wrapper">
                <div className="ft-floating-shape">
                  <span className="ft-shape-text ft-shape-text-1">Trusted Talent</span>
                  <span className="ft-shape-text ft-shape-text-2">Proven Results</span>
                </div>
              </div>
            </div>
          </div>

          {/* Row 4: Bottom bar */}
          <div className="ft-bottom-area">
            <div className="ft-legal-row">
              {/* <div className="ft-legal-links">
                <button type="button">Privacy Policy</button>
                <button type="button">Terms of Use</button>
                <button type="button">Cookie Policy</button>
              </div> */}
              <span className="ft-copyright">
                © {new Date().getFullYear()} Kapil Technologies. All Rights Reserved.
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* ── MOBILE / TABLET LAYOUT ─────────────────────── */}
      <div className="ft-mobile">
        <div className="ft-inner">
          <div className="ft-logo-row">
            <Link to="/" onClick={scrollToTop}>
              <img src={KcsTech} alt="Kapil Technologies logo" className="ft-logo" />
            </Link>
          </div>

          <div className="ft-mobile-desc">
            <p className="ft-desc-text">
              A technology-focused staffing partner connecting high-growth companies with skilled IT, engineering, and digital professionals.
            </p>
          </div>

          <AccordionSection title="Services">
            <ul className="ft-link-list">
              {serviceLinks.map((l) => (
                <li key={l.url}>
                  <Link to={l.url} onClick={scrollToTop}>{l.text}</Link>
                </li>
              ))}
            </ul>
          </AccordionSection>

          <AccordionSection title="Global Presence">
            <ul className="ft-link-list">
              {officeLocations.map((loc) => (
                <li key={loc}>{loc}</li>
              ))}
            </ul>
          </AccordionSection>

          <AccordionSection title="Company">
            <ul className="ft-link-list">
              {companyLinks.map((l) => (
                <li key={l.url}>
                  <Link to={l.url} onClick={scrollToTop}>{l.text}</Link>
                </li>
              ))}
            </ul>
          </AccordionSection>

          <AccordionSection title="Contact Us">
            <ul className="ft-link-list ft-contact-list">
              <li>
                <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
              </li>
              <li>
                <a href={`tel:${contactInfo.phone.replace(/\s/g, "")}`}>{contactInfo.phone}</a>
              </li>
              <li>{contactInfo.address}</li>
            </ul>
          </AccordionSection>

          {/* Social */}
          <div className="ft-social-row ft-social-row--mobile">
            <h2 className="ft-follow-heading">Follow Us</h2>
            <div className="ft-social-icons">
              {socialLinks.map((s) => (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  className="ft-social-icon"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Legal */}
          <div className="ft-legal-row">
            <div className="ft-legal-links">
              <button type="button" onClick={scrollToTop}>Privacy Policy</button>
              <button type="button" onClick={scrollToTop}>Terms of Use</button>
              <button type="button" onClick={scrollToTop}>Cookie Policy</button>
            </div>
            <span className="ft-copyright">
              © {new Date().getFullYear()} Kapil Technologies. All Rights Reserved.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
